import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import { Controller } from 'react-hook-form';
import { getFormRules } from 'helpers';

const ReviewDescInput = ({ item, errors, control, watch, trigger, handleBlur, handleFocus }) => {
    return (
        <div className="review__form--item full">
            <Controller
                render={({ onChange, onBlur, value }) => {
                    return (
                        <Form.Control
                            as="textarea"
                            name={item.name}
                            value={value}
                            placeholder={item.placeholder}
                            isInvalid={!!errors[item.name]}
                            type={'textarea'}
                            onChange={onChange}
                            onFocus={(e) => {
                                handleFocus(e.target.name);
                            }}
                            onBlur={(e) => {
                                onBlur(e);
                                trigger(e.target.name);
                                handleBlur();
                            }}
                        />
                    );
                }}
                control={control}
                name={item.name}
                rules={getFormRules({ items: item.rules, watch })}
                defaultValue=""
                onChange
            />
        </div>
    );
};

ReviewDescInput.propTypes = {
    item: PropTypes.object,
    data: PropTypes.any,
    control: PropTypes.object,
    watch: PropTypes.func,
    handleBlur: PropTypes.func,
    handleFocus: PropTypes.func,
    trigger: PropTypes.func,
};

export default ReviewDescInput;
